import { forwardRef } from 'react';
import { cellWidth } from 'utils/itineraries';
import ServiceTag, { SKINS } from 'components/ServiceTag';
import { IS_TENANT } from 'tenant/config';

const t = {
  export: 'exportación',
  import: 'importación',
  prio: 'Prio',
  ftb: 'FTB',
  recovering: 'Recovering',
  nonCore: 'RFQ',
  lh_express: 'LHE',
};

const DispatchingShipperCell = forwardRef(({ itinerary, width, minWidth, maxWidth }, ref) => {
  const is_export = IS_TENANT && itinerary?.is_multiroute && itinerary?.stops[1].type === 'PICKUP';
  const is_import = IS_TENANT && itinerary?.is_multiroute && itinerary?.stops[1].type === 'DROPOFF';
  return (
    <div
      className="cell cell__nowrap cell__dark cell__shipper pointer"
      {...cellWidth(width || minWidth, maxWidth)}
      ref={ref}
    >
      <span className="cell__shipper__name" data-testid="dispatchingListItem__shipper">
        {itinerary?.shipper?.company_name}{' '}
        {!!itinerary?.number_of_shippers && (
          <span className="cell__shipper__more">+{itinerary?.number_of_shippers}</span>
        )}
      </span>
      <div className="cell__shipper__tags" data-testid="dispatchingListItem__shipper__tags">
        {IS_TENANT ? (
          <>
            {is_export && (
              <ServiceTag text={t.export} skin={SKINS.grey} textTransform="uppercase" />
            )}
            {is_import && (
              <ServiceTag text={t.import} skin={SKINS.deepPurple} textTransform="uppercase" />
            )}
          </>
        ) : (
          <>
            {!!itinerary?.shipper?.is_prio && (
              <ServiceTag text={t.prio} skin={SKINS.primary} textTransform="uppercase" />
            )}
            {!!itinerary?.shipper?.is_ftb && (
              <ServiceTag text={t.ftb} skin={SKINS.success} textTransform="uppercase" />
            )}
            {!!itinerary?.shipper?.is_recovering && (
              <ServiceTag text={t.recovering} skin={SKINS.accent} textTransform="uppercase" />
            )}
            {itinerary?.is_core === false && (
              <ServiceTag text={t.nonCore} skin={SKINS.deepPurple} textTransform="uppercase" />
            )}
            {itinerary?.is_lh_express === true && (
              <ServiceTag text={t.lh_express} skin={SKINS.lhExpress} textTransform="uppercase" />
            )}
          </>
        )}
      </div>
    </div>
  );
});

export default DispatchingShipperCell;
